import classNames from 'classnames';
import React, { FC } from 'react';

import styles from './IconButton.module.css';

import { BaseIcon } from './BaseIcon';
import { IButtonProps } from '../Button/IButton.d';

const IconButton: FC<IButtonProps> = ({
  children,
  type = 'button',
  className,
  disabled = false,
  onClick = (): null => null,
}) => {
  const iconButtonClasses = classNames(
    `group ${styles['icon-btn']}`,
    className
  );

  return (
    <button
      type={type}
      className={iconButtonClasses}
      disabled={disabled}
      onClick={onClick}
    >
      <BaseIcon>{children}</BaseIcon>
    </button>
  );
};

export { IconButton };
